

























































































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Input, Button, Checkbox, Message,
} from 'element-ui';
import Sign from '@/servers/modules/signinsignup'; // server
import {
  Mutation, Getter,
} from 'vuex-class';
import copyBottom from './loginNewCompone/copyBottom';
import loginAndOtherComponent from './loginNewCompone/loginAndOtherComponent';

@Component({
  components: {
    Input,
    Button,
    Checkbox,
    Message,
    copyBottom,
    loginAndOtherComponent,
  },
})
export default class extends Vue {
  @Mutation public saveBasicData;

  @Mutation public saveLSBasicData;

  @Mutation public setNavData;

  @Getter public basicData: any;

  private form: any = {
    loginName: '',
    password: '',
  };

  private learnPlate: any = [
    {
      name: '词汇爆破',
      dec: 'VOCABULARY',
      id: 8,
      img: require('./loginNewImg/位图@2x.png'),
    },
    {
      name: '阅读闯关',
      dec: 'READING',
      id: 9,
      img: require('./loginNewImg/位图@2x(1).png'),
    },
    {
      name: '决胜中高考',
      dec: 'VICTORY',
      id: 10,
      img: require('./loginNewImg/位图@2x(2).png'),
    },
  ];

  private sharePlate: any = []

  private learnPlateOther: any = [
    {
      name: '评测追踪',
      img: require('./loginNewImg/图标／68px@2x.png'),
    },
    {
      name: '个性资源',
      img: require('./loginNewImg/图标／68px@2x(1).png'),
    },
    {
      name: '智能记忆',
      img: require('./loginNewImg/图标／68px@2x(2).png'),
    },
    {
      name: '迭代训练',
      img: require('./loginNewImg/图标／68px@2x(3).png'),
    },
    {
      name: '顾问指导',
      img: require('./loginNewImg/图标／68px@2x(4).png'),
    },
  ];

  private learn: any = {
    index: undefined,
    index1: undefined,
    index2: undefined,
  };

  // loading
  private loading: boolean = false;

  private flashTimer:any = '';

  jump_admin() {
    const { host } = location;
    console.log('host',host)
    let apiUrl = 'https://admin.ebopo.cn/#/login'
    if (host.indexOf('uat-') > -1) {
      apiUrl = 'https://uat-admin.ebopo.cn/#/login';
    }
    if (host.indexOf('pre-') > -1) {
      apiUrl = 'https://pre-admin.ebopo.cn/#/login';
    }
    if (host.indexOf('dev-') > -1) {
      apiUrl = 'https://dev-admin.ebopo.cn/#/login';      
    }
    if (host.indexOf('localhost') > -1) {
      apiUrl = 'https://dev-admin.ebopo.cn/#/login';      
    }
    window.location.href = apiUrl
  }

  // 登录按钮绑定回车键
  private keyupHandled(event: any) {
    // 回车登录
    if (event.keyCode == 13) {
      this.login();
    }
  }

  private created() {
    window.addEventListener('keyup', this.keyupHandled);
  }

  private beforeDestroy() {
    window.removeEventListener('keyup', this.keyupHandled);
    // 销毁闪动定时器
    clearInterval(this.flashTimer);
  }

  private toUrl(obj: object) {
    if (obj.type === '1') {
      window.open('https://www.ambow.com/');
      return;
    }
    this.$router.push({
      path: 'about',
      query: { type: obj.type },
    });
  }

  private async login() {
    if (!this.form.loginName) {
      Message.warning('请输入登录名');
      return false;
    }
    if (!this.form.password) {
      Message.warning('请输入密码');
      return false;
    }
    this.loading = true;
    const data = this.form;
    // const res = await Sign.login(data).catch(e=>{
    //   this.loading = false;
    // });
    // 新登录
    let res: any = await Sign.newLogin(data)
      .catch((e) => {
        this.loading = false;
      });

    res = res.data;
    if (!res.code) {
      res.data.gradeType = res.data.courseType;
      // 词汇跳到词汇
      let path: any = null;
      let nav: any = null;
      if (res.data && res.data.gradeType === 'word') {
        path = '/vocabulary';
        nav = 'vet';
      }
      // 阅读跳到阅读
      if (res.data && res.data.gradeType === 'read') {
        path = '/read';
        nav = 'read';
      }
      // 决胜跳到决胜
      if (res.data && res.data.gradeType === 'jse') {
        path = '/decisive';
        nav = 'jse';
      }
      // 保存 只能到达的模块路由类型
      res.data.modelType = path;
      // 重新保存 refID 避免后续其他页面需要使用
      res.data.refID = res.data.courseId;
      // 保存登录名
      res.data.loginName = this.form.loginName;
      // 存储基本数据
      window.LS.set('basicData', res.data);
      this.setNavData(nav);
      // // 判断是否第一次登录 如果这个字段为1  说明更新过个人资料
      // 不为1则提示用户输入资料
      window.LS.set('isFirstLoading', res.data.userInfoFlag);

      // 跳转对应模块主页 - (词汇-阅读-决胜)
      this.$router.push('/switchCourses');
    }
  }

  // 去注册
  private signup() {
    this.$router.push({ name: 'join' });
  }

  // 加载时请求接口
  private mounted() {
    window.$axios.post('/ebopo/api/content/getInfoByType', {
      contentTypeId: 6,
      page: 1,
      pageNum: 15,
    }).then((res:any) => {
      res = res.data;
      if (!res.data.code) {
        this.sharePlateList = res.data.info.list;

      }
      // 先初始化截取3个数组，以免出现数据没加载出来空屏的状态
      this.sharePlate = this.sharePlateList.slice(0, 3);
    });
    this.flashTimer = setInterval(this.flashing, 5000);
  }

  // 将初始值设定为3，为了避免第一组展示时间过长
  private sharePlateIndex:number = 3

  private sharePlateList:any = []

  // 学习榜样闪动的数据截取
  private flashing() {
    // 如果加进去的数据大于数组长度，则从0开始
    if (this.sharePlateIndex > this.sharePlateList.length - 1) {
      this.sharePlateIndex = 0;
    }
    // 每3组截取为数组，展示数据
    this.sharePlate = this.sharePlateList.slice(this.sharePlateIndex, this.sharePlateIndex + 3);
    // 截取数据后，index+3,准备下一次闪动
    this.sharePlateIndex = this.sharePlateIndex + 3;
  }

  // 去分享详情内容
  private goDetails(item:any) {
    window.LS.set('contentText', item.contentText);
    window.LS.set('title', item.title);
    this.$router.push({
      path: '/introduction',
      query: {
        id: 6, name: '学员案例', item: true, title: item.title,
      },
    });
  }

  // 学习流进入到说明界面
  private goDetail(item:any) {

    this.$router.push({ path: '/introduction', query: { id: item.id, name: item.name } });
  }

  // 去分享详情内容
  private goList() {
    this.$router.push({ path: '/introduction', query: { id: 6, name: '学员案例' } });
  }
}
